import React, { useEffect, useState } from 'react'

import './WealthTechLogoLoader.css'

const SVG_HEIGHT = 233.4
const PROGRESS_STEP = 1.2
const TICK_INTERVAL = 16
const RESET_DELAY = 300

function WealthTechLogoLoader({ className = '', style = {} }) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let resetTimeoutId = null

    const intervalId = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          if (!resetTimeoutId) {
            resetTimeoutId = setTimeout(() => {
              resetTimeoutId = null
              setProgress(0)
            }, RESET_DELAY)
          }
          return 100
        }

        return Math.min(prev + PROGRESS_STEP, 100)
      })
    }, TICK_INTERVAL)

    return () => {
      clearInterval(intervalId)
      if (resetTimeoutId) {
        clearTimeout(resetTimeoutId)
      }
    }
  }, [])

  const fillHeight = progress * 2.8
  const fillY = SVG_HEIGHT - fillHeight

  const containerClassName = ['wt-loader-container', className].filter(Boolean).join(' ')

  return (
    <div className={containerClassName} style={style}>
      <div className='wt-loader-inner'>
        <div className='wt-loader-logo'>
          <svg width='250' height='75' viewBox='0 0 1080 233.4' className='wt-loader-svg'>
            <defs>
              <radialGradient id='whiteFillGradient' cx='50%' cy='100%' r='80%'>
                <stop offset='0%' stopColor='#ffffff' />
                <stop offset='60%' stopColor='#ffffff' />
                <stop offset='85%' stopColor='#f8f9fa' />
                <stop offset='100%' stopColor='#e9ecef' />
              </radialGradient>

              <clipPath id='logoClip'>
                <polygon points='84.2,0 84.2,55.5 111.9,55.5 111.9,27.7 167.4,27.7 167.4,166.4 98.1,97.1 28.7,166.4 28.7,27.7 56.5,27.7 56.5,0 1,0 1,233.4 98.1,136.3 195.1,233.4 195.1,0' />
                <path d='M525.5,131.4c0,0-5.9,8.6-17.2,8.6c-5.8,0-13.4-1.7-13.4-9.5c0-8,8-10.5,13.7-10.5c10.2,0,16.9,3.8,16.9,3.8V131.4z M544.3,153.7v-48.3c0-16.9-12.5-27.6-33.7-27.6c-15.5,0-29.2,6.7-29.2,6.7l6.1,15.5c0,0,11.4-5.5,22.2-5.5c6.6,0,15.9,3.1,15.9,12.8v4.2c0,0-7-5.3-20.6-5.3c-16.1,0-29.1,10.3-29.1,24.5c0,15.8,12.8,24.8,26.7,24.8c16.7,0,24.4-11.2,24.4-11.2v9.4H544.3z' />
                <path d='M448.4,109.8h-36.7c0.6-6.6,6.1-15,18.1-15C442.1,94.8,448.1,103.4,448.4,109.8 M467.1,116.4c0-22.8-17-38.6-37.3-38.6c-21.4,0-37.2,17.2-37.2,38.9c0,21.7,17.3,38.9,39.8,38.9c18,0,29.7-10.6,29.7-10.6l-9.4-14.1c0,0-7.3,7.5-20.3,7.5c-11.7,0-19.4-8.4-20.8-15H467C467.1,120.6,467.1,117.8,467.1,116.4' />
                <polygon points='272.9,79.7 308.7,157.5 332.1,104.7 355.9,157.5 391.7,79.7 372.6,79.7 356.7,117.6 341.1,79.7 325.3,79.7 309.2,117.6 293.9,79.7' />
                <rect x='563.6' y='35.6' width='18.7' height='118.1' />
                <path d='M595.8,96.5h14.5v32.8c0,15.8,10.9,26.2,25.3,26.2c10.8,0,17.8-4.8,17.8-4.8l-6.9-15.3c0,0-3.6,2.7-7.8,2.7c-5,0-9.7-2.7-9.7-11.7V96.5h22.3V79.7h-22.3v-22h-18.7v22h-14.5V96.5z' />
                <path d='M707,77.8c-14.4,0-20.9,10.8-20.9,10.8v-53h-18.7v118.1h18.7V105c0,0,5-9.7,14.7-9.7c8.1,0,14.7,4.5,14.7,15.2v43.3h18.7v-48C734.2,87.9,721.4,77.8,707,77.8' />
                <path d='M750.2,116.7c0,6.9,5.5,12.3,12.3,12.3c6.9,0,12.3-5.5,12.3-12.3c0-6.9-5.5-12.3-12.3-12.3C755.6,104.3,750.2,109.8,750.2,116.7' />
                <path d='M905,109.8h-36.7c0.6-6.6,6.1-15,18.1-15C898.7,94.8,904.6,103.4,905,109.8 M923.7,116.4c0-22.8-17-38.6-37.3-38.6c-21.4,0-37.2,17.2-37.2,38.9c0,21.7,17.3,38.9,39.8,38.9c18,0,29.7-10.6,29.7-10.6l-9.4-14.1c0,0-7.3,7.5-20.3,7.5c-11.7,0-19.4-8.4-20.8-15h55.3C923.7,120.6,923.7,117.8,923.7,116.4' />
                <path d='M784.8,96.5h14.5v32.8c0,15.8,10.9,26.2,25.3,26.2c10.8,0,17.8-4.8,17.8-4.8l-6.9-15.3c0,0-3.6,2.7-7.8,2.7c-5,0-9.7-2.7-9.7-11.7V96.5h22.3V79.7h-22.3v-22h-18.7v22h-14.5V96.5z' />
                <path d='M970.7,138.1c-12.7,0-20.8-9.8-20.8-21.4s8.1-21.4,20.8-21.4c11.2,0,17.3,7.8,17.3,7.8l13-11.6c0,0-10.5-13.7-30.3-13.7c-22.2,0-39.8,17-39.8,38.9c0,21.7,17.7,38.9,39.8,38.9c20,0,30.6-14.1,30.6-14.1L989,129C989,129,983.4,138.1,970.7,138.1' />
                <path d='M1053.8,77.8c-14.4,0-20.9,10.8-20.9,10.8v-53h-18.7v118.1h18.7V105c0,0,5-9.7,14.7-9.7c8.1,0,14.7,4.5,14.7,15.2v43.3h18.7v-48C1081,87.9,1068.2,77.8,1053.8,77.8' />
              </clipPath>
            </defs>

            <g fill='#009999'>
              <polygon points='84.2,0 84.2,55.5 111.9,55.5 111.9,27.7 167.4,27.7 167.4,166.4 98.1,97.1 28.7,166.4 28.7,27.7 56.5,27.7 56.5,0 1,0 1,233.4 98.1,136.3 195.1,233.4 195.1,0' />
              <path d='M525.5,131.4c0,0-5.9,8.6-17.2,8.6c-5.8,0-13.4-1.7-13.4-9.5c0-8,8-10.5,13.7-10.5c10.2,0,16.9,3.8,16.9,3.8V131.4z M544.3,153.7v-48.3c0-16.9-12.5-27.6-33.7-27.6c-15.5,0-29.2,6.7-29.2,6.7l6.1,15.5c0,0,11.4-5.5,22.2-5.5c6.6,0,15.9,3.1,15.9,12.8v4.2c0,0-7-5.3-20.6-5.3c-16.1,0-29.1,10.3-29.1,24.5c0,15.8,12.8,24.8,26.7,24.8c16.7,0,24.4-11.2,24.4-11.2v9.4H544.3z' />
              <path d='M448.4,109.8h-36.7c0.6-6.6,6.1-15,18.1-15C442.1,94.8,448.1,103.4,448.4,109.8 M467.1,116.4c0-22.8-17-38.6-37.3-38.6c-21.4,0-37.2,17.2-37.2,38.9c0,21.7,17.3,38.9,39.8,38.9c18,0,29.7-10.6,29.7-10.6l-9.4-14.1c0,0-7.3,7.5-20.3,7.5c-11.7,0-19.4-8.4-20.8-15H467C467.1,120.6,467.1,117.8,467.1,116.4' />
              <polygon points='272.9,79.7 308.7,157.5 332.1,104.7 355.9,157.5 391.7,79.7 372.6,79.7 356.7,117.6 341.1,79.7 325.3,79.7 309.2,117.6 293.9,79.7' />
              <rect x='563.6' y='35.6' width='18.7' height='118.1' />
              <path d='M595.8,96.5h14.5v32.8c0,15.8,10.9,26.2,25.3,26.2c10.8,0,17.8-4.8,17.8-4.8l-6.9-15.3c0,0-3.6,2.7-7.8,2.7c-5,0-9.7-2.7-9.7-11.7V96.5h22.3V79.7h-22.3v-22h-18.7v22h-14.5V96.5z' />
              <path d='M707,77.8c-14.4,0-20.9,10.8-20.9,10.8v-53h-18.7v118.1h18.7V105c0,0,5-9.7,14.7-9.7c8.1,0,14.7,4.5,14.7,15.2v43.3h18.7v-48C734.2,87.9,721.4,77.8,707,77.8' />
              <path d='M750.2,116.7c0,6.9,5.5,12.3,12.3,12.3c6.9,0,12.3-5.5,12.3-12.3c0-6.9-5.5-12.3-12.3-12.3C755.6,104.3,750.2,109.8,750.2,116.7' />
              <path d='M905,109.8h-36.7c0.6-6.6,6.1-15,18.1-15C898.7,94.8,904.6,103.4,905,109.8 M923.7,116.4c0-22.8-17-38.6-37.3-38.6c-21.4,0-37.2,17.2-37.2,38.9c0,21.7,17.3,38.9,39.8,38.9c18,0,29.7-10.6,29.7-10.6l-9.4-14.1c0,0-7.3,7.5-20.3,7.5c-11.7,0-19.4-8.4-20.8-15h55.3C923.7,120.6,923.7,117.8,923.7,116.4' />
              <path d='M784.8,96.5h14.5v32.8c0,15.8,10.9,26.2,25.3,26.2c10.8,0,17.8-4.8,17.8-4.8l-6.9-15.3c0,0-3.6,2.7-7.8,2.7c-5,0-9.7-2.7-9.7-11.7V96.5h22.3V79.7h-22.3v-22h-18.7v22h-14.5V96.5z' />
              <path d='M970.7,138.1c-12.7,0-20.8-9.8-20.8-21.4s8.1-21.4,20.8-21.4c11.2,0,17.3,7.8,17.3,7.8l13-11.6c0,0-10.5-13.7-30.3-13.7c-22.2,0-39.8,17-39.8,38.9c0,21.7,17.7,38.9,39.8,38.9c20,0,30.6-14.1,30.6-14.1L989,129C989,129,983.4,138.1,970.7,138.1' />
              <path d='M1053.8,77.8c-14.4,0-20.9,10.8-20.9,10.8v-53h-18.7v118.1h18.7V105c0,0,5-9.7,14.7-9.7c8.1,0,14.7,4.5,14.7,15.2v43.3h18.7v-48C1081,87.9,1068.2,77.8,1053.8,77.8' />
            </g>

            <rect
              x='-50'
              y={fillY}
              width='1180'
              height={fillHeight}
              fill='url(#whiteFillGradient)'
              clipPath='url(#logoClip)'
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default WealthTechLogoLoader

